import { render, staticRenderFns } from "./NewFormBuilder.vue?vue&type=template&id=143fa545&scoped=true"
import script from "./NewFormBuilder.vue?vue&type=script&lang=js"
export * from "./NewFormBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143fa545",
  null
  
)

export default component.exports